// Un nom de question n’est pas un chemin. Encoder les caractères réservés
// conserve les noms existants ordinaires et évite toute ambiguïté (y compris %).
// Le nom obtenu doit encore être encodé avec encodeURIComponent dans une URL.
function exchangeDocumentBaseName(name) {
  return String(name || '')
    .replace(/[%/\\\x00-\x1f\x7f]/g, character => encodeURIComponent(character))
    .replace(/^\.+/, dots => dots.replace(/\./g, '%2E'));
}
const DOCUMENT_NAME_MAX_LENGTH = 120;
const DOCUMENT_NAME_HELP = 'Lettres non accentuées (A-Z, a-z), chiffres, espaces et underscores (_) uniquement. Commencez par une lettre ou un chiffre, sans espace final. 120 caractères maximum. Exemple : CNI_Passeport ou Releve de notes.';

// Les anciens noms inchangés restent lisibles : les renommer sans déplacer les
// documents existants couperait leur association avec la question.
function fileQuestionNameError(question, previous) {
  if (question?.type !== 'file') return '';
  if (previous?.type === 'file' && previous.nom === question.nom) return '';
  const name = question.nom;
  if (typeof name !== 'string' || !name.trim()) return 'Le nom de la pièce jointe est obligatoire.';
  if (name.length > DOCUMENT_NAME_MAX_LENGTH) return `Le nom de la pièce jointe est limité à ${DOCUMENT_NAME_MAX_LENGTH} caractères.`;
  if (!/^[A-Za-z0-9][A-Za-z0-9 _]*$/.test(name) || name !== name.trim()) {
    return 'Nom de pièce jointe invalide. ' + DOCUMENT_NAME_HELP;
  }
  return '';
}
module.exports = { exchangeDocumentBaseName, fileQuestionNameError, DOCUMENT_NAME_HELP };
